import create from 'zustand';

type ModalType = 'login' | 'confirm';

interface ModalState {
  opened: boolean;
  isClosable: boolean;
  redirectUrl?: string;
  modalType: ModalType;
  setIsClosable: (state: boolean) => void;
  openModal: () => void;
  closeModal: () => void;
  setRedirectUrl: (url: string) => void;
  setModalType: (type: ModalType) => void;
}

export const useModalStore = create<ModalState>(set => ({
  opened: false,
  isClosable: true,
  redirectUrl: '',
  modalType: 'login',
  openModal: () => set({ opened: true }),
  closeModal: () => set({ opened: false }),
  setIsClosable: state => set({ isClosable: state }),
  setRedirectUrl: url => set({ redirectUrl: url }),
  setModalType: type => set({ modalType: type })
}));

export const closeModal = () => useModalStore.getState().closeModal;
export const openModal = () => useModalStore.getState().openModal;
export const modalisOpen = () => useModalStore.getState().opened;
export const setIsClosable = (state: boolean) =>
  useModalStore.setState({ isClosable: state });

export default useModalStore;
